<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="apiUrl"
      :columns="columns"
      :type="type"
    >
      <template #cell(upload_to_fasah)="data">
        <span
          class="cursor-pointer"
          @click="showEngineersList(data.item.id)"
        >
          <img
            src="@/assets/images/icons/upload.png"
            width="35"
            height="35"
          >
        </span>
      </template>
    </general-table>
  </div>
</template>

<script>
import axios from 'axios'
import GeneralTable from '@/components/general-table/GeneralTable.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  components: { GeneralTable },
  data() {
    return {
      APIURL: 'sfda/pending-certificates',
      type: 'page',
      partners: [],
      filter: {},
      types: '',
      columns: [
        { key: 'request_code', label: 'Request Code' },
        { key: 'status', label: 'status' },
        { key: 'source_name', label: 'source' },
        { key: 'certificate_number', label: 'certificate number' },
        { key: 'upload_to_fasah', label: 'Upload To Fasah' },
      ],
    }
  },

  computed: {

    apiUrl() {
      let base = 'sfda/pending-certificates?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  methods: {

    showEngineersList(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Do you want to upload this to Fasah?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Proceed',
        cancelButtonText: 'Cancel',
      }).then(result => {
        if (result.isConfirmed) {
          this.$swal({
            title: 'Loading...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              this.$swal.showLoading()
            },
          })

          const formData = new FormData()
          formData.append('request_id', id)

          axios
            .post('/sfda/certificate/send-to-fasah', formData)
            .then(() => {
              this.$swal.close()
              this.$swal({
                icon: 'success',
                title: 'Uploaded Successfully!',
                text: 'Certificate uploaded to Fasah successfully.',
              })

              // 🔄 Optional refresh the table after upload
              this.$refs.generalTable.getAllData(1)
            })
            .catch(error => {
              this.$swal.close()
              const payload = decryptData(error?.response?.data?.payload)?.message

              this.$swal({
                icon: 'error',
                title: 'Failed to upload to Fasah',
                text: payload || 'Please try again later.',
              })
            })
        }
      })
    },
  },
}
</script>

  <style></style>
